export default {
  name: 'plotEvidence',
  options: {
    menuIndex: 5,
    isHidden: true,
  },
};
